export let dataProps = {
    id: 0,
    status: 0, 
    campaign_title: '',
    schedule_date: '',
    store_id: null,
    email_subject: '',
    email_message: '',
    whatsapp_message: '',
    whatsapp_attachment: '',
    sms: '',
    sms_template_id: '',
    sms_entity_id: '',
    customer_list: [],
    internal_remarks: '',
    nav: {
        search_term: '',
        search_criteria: []
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/campaign/properties.js